import { useEffect, useState } from "react";
import { Row, message, Pagination } from "antd";
import { useDispatch } from "react-redux";

import Upload from "@components/Upload";
import Table from "@components/Table";
import { getVersionsColumns } from "./config";
import {
  ErrorServices,
  marketDataApi,
  useFetchMarketDataVersionsQuery,
  useUpdateMarketDataVersionMutation,
  useUploadMarketDataMutation,
} from "@services";
import { IVersion } from "@types";
import { useTypedSelector } from "@hooks";
import { checkPermission } from "@/utils";
import { permissions } from "@/router";
import { MdOutlineFileDownload, MdOutlineFileUpload } from "react-icons/md";
import CustomButton from "@/components/customButton";
import SearchBox from "@/components/searchInput";
import customErrorMessage from "@/components/CustomErrorMessage";
import UploadButton from "@/components/UploadButton";

const MarketData = () => {
  const { company, role } = useTypedSelector(state => state.auth?.user!);
  const { id: company_id } = company!;
  const dispatch = useDispatch();

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const { data: versions, isLoading } = useFetchMarketDataVersionsQuery({
    page: currentPage,
    company_id,
    page_size: pageSize,
  });

  const [updateMarketDataVersion] = useUpdateMarketDataVersionMutation();
  const [uploadMarketData, { isLoading: isUploading }] =
    useUploadMarketDataMutation();

  const { data = [], pagination } = versions || {};
  const totalItems = pagination?.count || 0;

  const [isUploadModal, setIsUploadModal] = useState(false);
  const [currentId, setCurrentId] = useState<null | number>(null);
  const [searchInput, setSearchInput] = useState("");
  const [uploadFile, setUploadFile] = useState({
    file: null,
    active: false,
  });

  // Select current active version
  useEffect(() => {
    if (data?.length) {
      const activeVersion = data.find(
        (version: IVersion) => version?.is_active === "TRUE"
      );
      if (activeVersion) setCurrentId(activeVersion.id);
    }
  }, [data]);

  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const handleActive = async (id: number) => {
    try {
      setCurrentId(id);
      await updateMarketDataVersion({ id, company_id }).unwrap();
    } catch (error) {
      ErrorServices(error);
    }
  };

  const handleUpload = async () => {
    const { file, active } = uploadFile;
    setIsUploadModal(false);
    try {
      const formData = new FormData();
      formData.append("attachment", file!, file?.name!);
      const res = await uploadMarketData({
        company_id,
        active,
        body: formData,
      }).unwrap();
      message.success(res?.message);
    } catch (error) {
      customErrorMessage(error?.message);
    }
  };

  const download = (id?: number) => {
    dispatch(
      marketDataApi.endpoints.downloadMarketData.initiate(
        {
          company_id,
          version_id: id || null,
        },
        {
          subscribe: false,
          forceRefetch: true,
        }
      )
    );
  };

  const versionsColumns = getVersionsColumns({
    handleActive,
    currentId,
    download,
  });

  return (
    <>
      {isUploadModal && (
        <Upload
          title="Upload Market Data"
          onSubmit={handleUpload}
          isVisible={isUploadModal}
          setIsVisible={setIsUploadModal}
          file={uploadFile}
          setFile={setUploadFile}
        />
      )}

      <div className="bg-white p-4 sm:p-5">
        <div className="jobCreationBar bg-revampBlue px-4 py-6 rounded-lg flex justify-between items-center">
          <div className="title text-white font-medium text-3xl uppercase">
            Market Data
          </div>

          <div className="flex flex-row justify-between">
            <UploadButton
              role={role}
              createPermission={permissions.CREATE_INTERNAL_PAYROLL}
              updatePermission={permissions.UPDATE_INTERNAL_PAYROLL}
              onClick={() => setIsUploadModal(true)}
              isLoading={isUploading}
            />

            <CustomButton
              onClick={() => download()}
              btnName="Download"
              customClasses="shadow-md font-medium border py-1 px-6 !border-themeBorder ml-4"
              iconPosition="right"
            >
              {/* <MdOutlineFileDownload
                size={20}
                className="text-white font-bold"
              /> */}
            </CustomButton>

            <SearchBox
              placeholder="Type to search..."
              value={searchInput}
              onChange={value => setSearchInput(value)}
            />
          </div>
        </div>
      </div>

     

      <div className="jobCreationListing mt-6 bg-white px-5 py-4 rounded-lg">
        {/* <SearchBox
          placeholder="Type to search..."
          value={searchInput}
          onChange={value => setSearchInput(value)}
        /> */}

        <Row>
          <Table
            isLoading={isLoading}
            data={data}
            columns={versionsColumns}
            pagination={true} // External Pagination only
            count={pagination?.count}
            onChangePage={page => setCurrentPage(page)}
            onPageSizeChange={setPageSize}
            page={currentPage}
          />
        </Row>

        {/* <div className="flex justify-center mt-6">
          <Pagination
            current={currentPage}
            total={totalItems}
            pageSize={10} // should match backend
            onChange={page => setCurrentPage(page)}
            showSizeChanger={false}
          />
        </div> */}
      </div>
    </>
  );
};

export default MarketData;
